<template>
    <el-dialog
        :visible.sync="hide_show_coverage_grouped_coverage_activity_modal"
        custom-class="custom-class-groupped-coverage-section"
    >
        <el-row :gutter="20" class="mb-3">
			<el-col :span="24">
				<div style="display: flex; justify-content: space-between" class="mb-2">
					<h2 class="popup-title">All sectional coverage activities</h2>
					<!-- <el-button
						icon="el-icon-close"
						size="mini"
						circle
						@click="hide_show_coverage_grouped_coverage_activity_modal = false"
					></el-button> -->
                    <i
                        class="el-icon-circle-close cursor-pointer"
                        style="font-size: 25px;"
                        @click="hide_show_coverage_grouped_coverage_activity_modal = false"
                    ></i>
				</div>
			</el-col>
		</el-row>
        <el-row :gutter="20" class="mb-3">
			<el-col :span="24">
                <template>
                    <el-table
                        :data="grouped_store_setting_coverage_activities"
                        style="width: 100%"
                    >
                        <el-table-column
                            label="Section"
                            width="180"
                        >
                            <template slot-scope="scope">
                                {{ getSectionName(scope.row.section_id) }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="station_name"
                            label="Station"
                            width="180"
                        ></el-table-column>
                        <el-table-column label="Planning Level">
                            <template slot-scope="scope">
                                {{ scope.row.planning_criteria ? scope.row.planning_criteria : '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="Order Type">
                            <template slot-scope="scope">
                                <template v-if="scope.row.order_type && scope.row.order_type.length">
                                    <order-type-tag v-for="(orderTypeItem, orderTypeIndex) in scope.row.order_type" :key="'orderTypeItem-'+orderTypeIndex">{{ orderTypeItem }}</order-type-tag>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column>
                            <template slot-scope="scope">
                                <div class="text-right">
                                    <span class="col-element">
                                        <span class="mr-4">
                                            <img
                                                src="../../../../../assets/icons/edit-icon.svg"
                                                width="12"
                                                class="cursor-pointer"
                                                @click="editUpdatedCoverageActivity(scope.row.section_id, scope.row.unique_index)"
                                            />
                                        </span>
                                    </span>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
			</el-col>
		</el-row>
    </el-dialog>
</template>

<script>
import settingsMixin from "../../../../../../mixins/settingsMixin";
import OrderTypeTag from "./OrderTypeTag.vue";
export default {
    name: "GroupedCoverageActivityList",
    components: {
        OrderTypeTag
    },
    mixins: [settingsMixin],
}
</script>


<style lang="scss">
.company-settings .custom-class-add-or-edit-section {
	.el-dialog__header {
		display: none;
	}
}
.store-settings .custom-class-groupped-section {
	.el-dialog__header {
		display: none;
	}
}
</style>
